<script setup>
import Badge from "@/components/atoms/badge";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import ButtonIcon from "@/components/molecules/button-icon";
import ajouterCarteCarrefour from "@/assets/images/espace-fid/illus-ajout-carte-club.svg";
import transfererCagnottes from "@/assets/images/espace-fid/illus-transfert-cagnotte.svg";

const emit = defineEmits(["addCarte"]);
</script>
<template>
  <div>
    <Card
      border-color="border"
      radius="md"
      class="u-mb-md u-border-none@md"
    >
      <div class="u-flex u-flex-column@lg u-flex-justify-around u-flex-align-center u-gap-md u-px-sm">
        <div class="u-flex u-flex-column@md u-flex-align-center u-gap-xs">
          <Badge
            variant="primary"
            circle
          >1</Badge>
          <div class="u-flex u-flex-align-center u-flex-column-reverse@md u-gap-xs">
            <LazyImage
              width="100"
              :src="ajouterCarteCarrefour"
              alt=""
            />
            <p>
              Ajoutez ou créez votre Carte
            </p>
          </div>
        </div>
        <div class="u-flex u-flex-column@md u-flex-align-center u-gap-xs">
          <Badge
            variant="primary"
            circle
          >2</Badge>
          <div class="u-flex u-flex-align-center u-flex-column-reverse@md u-gap-xs">
            <LazyImage
              width="166"
              :src="transfererCagnottes"
            />
            <p>
              Transférez votre cagnotte Cora
            </p>
          </div>
        </div>
      </div>
    </Card>
    <div class="u-flex u-flex-wrap u-gap-sm u-flex-justify-center u-mt-md">
      <Button
        variant="primary"
        radius="full"
        size="sm"
        class="u-max-width-25 u-full-width"
        @click="emit('addCarte')"
      >Ajouter ma Carte</Button>
      <ButtonIcon
        variant="primary"
        radius="full"
        size="sm"
        outline
        icon-name="external"
        icon-position="right"
        icon-color="primary"
        class="u-max-width-25 u-full-width"
        target="_blank"
        to="https://www.carrefour.fr/mon-compte/inscription"
      >Créer ma Carte</ButtonIcon>
    </div>
  </div>
</template>